import reducer from "./reducers";

import * as priviligesAction from "./actions";

export { priviligesAction };

export default reducer;
